<template>
    <header id="header-m">
        <div class="menu">
            <ul>
                <li  style="animation-delay: 0.1s"><a href="/home.html">首页</a></li>
                <li style="animation-delay: 0.2s"><a href="/about.html">慈华臻品</a></li>
                <li style="animation-delay: 0.3s"><a href="/pro.html">产品中心</a></li>
                <li style="animation-delay: 0.4s"><a href="/news.html">新闻资讯</a></li>
                <li style="animation-delay: 0.5s"><a href="/contact.html">联系我们</a></li>
            </ul>
<!--            <div class="lan" style="animation-delay: 0.7s">-->
<!--                <span>CN</span>-->
<!--                <span>EN</span>-->
<!--            </div>-->
        </div>
    </header>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    export default {
        data(){
            return{
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    header{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100vw;
        background-color: #CBAE85;
        height:50vh;
        z-index: 100;
        transform: translateX(30%);
    }
    header  .menu ul li{
        padding: 15px 0;
        text-transform: uppercase;
        font-family: SourceHanSerifCN-Regular;
        opacity: 0;
        transition: all 1s;
    }
    header .menu ul li a{
        color:white;
        font-size: 12px;
    }
    header .menu .lan{
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    header .menu .lan span{
        display: inline-block;
        width:20%;
        text-align: center;
        color:white;
        font-size: 12px;
    }
    header .menu ul{
        display: block;
        font-size: 18px;
        width:100%;
        padding: 18px 0px;
        text-align: center;
        list-style: none;
        padding-bottom: 60px;
    }
    .show{
        transform: translateX(0);
        transition: .4s;
    }
    .show .menu ul li{
        animation: goShow forwards 1s linear;
        opacity: 1;
    }
    .show .menu .lan{
        animation: goShow forwards 1s linear;
        opacity: 1;
    }
    @keyframes goShow {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }


</style>
